let interval = null

export default function startClock() {
  clearInterval(interval)
  interval = null

  if ($('#clock').length == 0) return

  interval = setInterval(() => {
    $('#clock').text(new Date().toTimeString().split(' ')[0])
  }, 1000)
}
